// import { Typography } from '@mui/material';
import Typography from '@/components/shared/typography/typography.component';
import styles from './styles.module.scss';
import { ReactNode } from 'react';
import { IVariant } from '@/components/shared/typography/typography.types';

interface ComponentProps {
    children?: ReactNode;
}
interface CustomTypographyProps extends ComponentProps {
    variant?: IVariant;
}
interface CustomTypographyProps2 extends ComponentProps {
    onClick: () => void;
}
const CarProfileSectionHeaderContainer = ({ children }: ComponentProps) => {
    return (
        <div className={styles.CarProfileSectionHeaderContainer}>
            <>{children}</>
        </div>
    );
};

const CarProfileSectionHeaderTitle = ({
    children,
    variant,
}: CustomTypographyProps) => {
    return (
        <Typography
            className={styles.CarProfileSectionHeaderTitle}
            variant={variant}
        >
            <>{children}</>
        </Typography>
    );
};
const CarProfileSectionViewMoreNoBorder = ({
    children,
    onClick,
}: CustomTypographyProps2) => {
    return (
        <div
            className={styles.CarProfileSectionViewMoreNoBorder}
            onClick={onClick}
        >
            <>{children}</>
        </div>
    );
};

const CarProfileViewMoreContainerMobile = ({
    children,
    onClick,
}: CustomTypographyProps2) => {
    return (
        <div
            className={styles.CarProfileViewMoreContainerMobile}
            onClick={onClick}
        >
            <>{children}</>
        </div>
    );
};

const CarProfileViewMoreContainer = ({
    children,
    onClick,
}: CustomTypographyProps2) => {
    return (
        <div className={styles.CarProfileViewMoreContainer} onClick={onClick}>
            <>{children}</>
        </div>
    );
};

const CarProfileSectionViewMore = ({
    children,
    variant,
}: CustomTypographyProps) => {
    return (
        <Typography
            className={styles.CarProfileSectionViewMore}
            variant={variant}
        >
            <>{children}</>
        </Typography>
    );
};

export {
    CarProfileSectionHeaderContainer,
    CarProfileSectionHeaderTitle,
    CarProfileViewMoreContainer,
    CarProfileSectionViewMore,
    CarProfileViewMoreContainerMobile,
    CarProfileSectionViewMoreNoBorder,
};
